export function avatarFallbackColorSelector(userUuid = "") {
    const lastCharacterOfUserUuid: string = userUuid.charAt(
        userUuid.length - 1,
    );

    return AVATAR_FALLBACK_BACKGROUND_COLOR[
        lastCharacterOfUserUuid.length > 0
            ? lastCharacterOfUserUuid.toUpperCase()
            : 0
    ];
}

const avatarFallbackColorArrOfKeys = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "F",
];
export function getRandomAvatarFallbackColor() {
    return AVATAR_FALLBACK_BACKGROUND_COLOR[
        avatarFallbackColorArrOfKeys[Math.floor(Math.random() * 15)]
    ];
}

enum AVATAR_FALLBACK_BACKGROUND_COLOR {
    "#596E38",
    "#385D6E",
    "#386E4E",
    "#473A6E",
    "#50739D",
    "#50849D",
    "#575D9D",
    "#6E3861",
    "#6E4238",
    "#6E6B38",
    "A" = "#7F9D50",
    "B" = "#9D508B",
    "C" = "#9D7550",
    "D" = "#9D9350",
    "E" = "#9D5052",
    "F" = "#78509D",
}
